<i18n>
{
  "en": {
    "title": "Sustainable Data Center Highlights 2017-2018",
    "description": "Sustainability is at the heart of our Buildings & IT business. We help customers reduce their impact on the environment while increasing speed of deployment and maximizing uptime in an increasingly digital world. Read about our green data center solutions and Telefónica’s sustainable success story.",
    "ourCustomers": {
      "section": "Our Customers",
      "title": "Data Center",
      "data": {
        "txt1": {
          "title": "Sustainable data center highlights",
          "para1": "The data center and network industry is undergoing profound transformation to support the enormous data volumes that IoT generates. Our Buildings &amp; IT business helps customers manage unique challenges and meet demand in a rapidly growing market.",
          "para2": "Sustainability is at the heart of our Buildings &amp; IT business, where we help customers save energy while increasing speed of deployment and maximizing uptime. Through connected products; edge control; and apps, analytics, and services, Schneider Electric offers end-to-end data center physical infrastructure to ensure IT environments of all sizes are highly available and efficient &mdash; overseeing processes from planning and design to commissioning, operations, and maintenance. ",
          "para3": "EcoStruxure ensures that the data center physical infrastructure can adapt quickly to support both future demand driven by IoT and growth &mdash; in the cloud and at the edge, or a hybrid environment &mdash; without compromising availability or operational efficiency. EcoStruxure<sup>&trade;</sup> helps set data center clients up for success with:",
          "listItem1": "Increased speed of deployment",
          "listItem2": "Enhanced visibility and management",
          "listItem3": "Mitigated risks",
          "listItem4": "Maximized uptime"
        },
        "table1": {
          "title": "A sample of our data center solutions",
          "row1": {
            "cell1": "Apps, Analytics &amp; Services",
            "cell2": "",
            "cell3": {
              "title": "EcoStruxure Asset Advisor",
              "para": "Anticipate and address issues before they become critical incidents with this 24/7, data-driven, predictive service."
            }
          },
          "row2": {
            "cell1": "Edge Control",
            "cell2": "",
            "cell3": {
              "title": "EcoStruxure IT Expert",
              "para": "Gain visibility and monitoring from anywhere with one-tap access direct from any computer or mobile device."
            }
          },
          "row3": {
            "cell1": "Connected Products",
            "cell2": "",
            "cell3": {
              "title": "Galaxy VX 3-phase UPS",
              "para": "Protect the uptime of large facilities, data centers, and business-critical application with this scalable UPS."
            }
          }
        },
        "quote": {
          "text": "We created a project I'm very proud of, and specifically, we reduced energy costs by 60 percent compared to a traditional data center.",
          "author": "Fran Muña",
          "title": "Director of Critical Infrastructure,",
          "company": "Telefónica"
        },
        "vid": {
          "title": "Digital Telco Journey",
          "description": "Modernizing for today and tomorrow's demands with increased energy"
        },
        "txtMedia1": {
          "title1": "Sustainable data center success story: Telefónica",
          "title2": "Telefónica's sustainability journey",
          "para1": "Telefónica had a bold vision to extend its telephone business to become a digital telecommunication company, creating a high-density data center to meet customer demand while reducing energy costs. EcoStruxure for Data Center allows Telefónica’s Alcalá data center to process a staggering 14 kW per rack while ensuring reliable services and reducing energy costs by 60 percent, compared to both traditional data center infrastructure management (DCIM) and the Gold Tier IV<sup>&reg;</sup> certification."
        },
        "table2": {
          "title": "Les solutions durables pour Telefónica",
          "row1": {
            "cell1": "What",
            "cell2": "Why"
          },
          "row2": {
            "cell1": "Remote Monitoring Services",
            "cell2": "To monitor the status of every component of the installation in real time, allowing for early failure detection and delivering the strictest standards in reliability"
          },
          "row3": {
            "cell1": "LV Electric Box, Building Lighting, UPS",
            "cell2": "Efficient reductions in energy consumption and CO₂ emissions; a distributed technology-based system that controls and monitors the building, while simultaneously managing the alarms and energy infrastructure"
          },
          "row4": {
            "cell1": "Automation servers, network controllers, room controllers, LV / MV switchgear, transformers, power meters, circuit breakers, variable speed drives, UPS, and wiring devices",
            "cell2": {
              "p1": "Building automation and control systems for innovative building management that inspire occupant productivity and deliver optimal energy and operational efficiency"
            }
          }
        },
        "tableText": {
          "title": "Recorded benefits to date include:",
          "listItem1": "A 60% reduction in energy costs compared to both traditional DCIM and the Gold Tier IV<sup>&reg;</sup> certification",
          "listItem2": "Ability to connect new servers in running mode, with no need to stop to reconfigure or redesign systems",
          "listItem3": "A BMS that collects data from some 45,000 elements",
          "p1": "<strong>Get the facts on Telefónica's challenges, sustainable solutions, and results.</strong>",
          "ctaText": "Learn more"
        }
      }
    }
  },
  "fr": {
    "title": "Sustainable Data Center Highlights 2017-2018",
    "description": "Sustainability is at the heart of our Buildings & IT business. We help customers reduce their impact on the environment while increasing speed of deployment and maximizing uptime in an increasingly digital world. Read about our green data center solutions and Telefónica’s sustainable success story.",
    "ourCustomers": {
      "section": "Nos Clients",
      "title": "Centres de Données",
      "data": {
        "txt1": {
          "title": "Faits marquants centres de données durables",
          "para1": "Le secteur des réseaux et des centres de données est en pleine mutation pour absorber les énormes volumes de données générés par l’IdO. Notre activité Basse Tension & Energie sécurisée  aide les clients à gérer ces défis d'un genre particulier et à répondre à la demande dans un marché en expansion rapide.",
          "para2": "Le développement durable est au cœur de notre activité Basse Tension & Énergie sécurisée, puisque nous aidons nos clients à économiser de l’énergie tout en accélérant leur déploiement et en maximisant leur disponibilité. Grâce à ses produits connectés, à ses solutions de contrôle local, et à ses applications, outils d’analyse et services, Schneider Electric propose des infrastructures physiques complètes qui assurent disponibilité et efficacité à des environnements informatiques de toutes tailles. Le Groupe supervise l’ensemble du processus, de la planification à la maintenance, en passant par la conception, la mise en service et l’exploitation.",
          "para3": "EcoStruxure garantit que l'infrastructure physique de votre centre de données s’adapte rapidement pour répondre à la fois à la demande future générée par l'IdO et à la croissance, sur le cloud et dans les réseaux périphériques, ou encore dans un environnement hybride, sans jamais compromettre la disponibilité ou l'efficacité opérationnelle. Raisons qui font d’EcoStruxure un gage du succès des centres de données :",
          "listItem1": "Vitesse de déploiement accrue",
          "listItem2": "Amélioration de la visibilité et de la gestion",
          "listItem3": "Maîtrise des risques",
          "listItem4": "Réduction du temps de latence"
        },
        "table1": {
          "title": "Exemples de nos solutions pour les centres de données",
          "row1": {
            "cell1": "Applications, outils d'analyse et services ",
            "cell2": "",
            "cell3": {
              "title": "EcoStruxure Asset Advisor",
              "para": "Anticiper et résoudre les problèmes avant qu'ils ne deviennent des incidents critiques grâce à ce service 24/7, à base de données et prédictif "
            }
          },
          "row2": {
            "cell1": "Contrôle local (edge control)",
            "cell2": "",
            "cell3": {
              "title": "EcoStruxure IT Expert",
              "para": "Gagner en visibilité et en supervision partout grâce à un accès direct soit d'un ordinateur ou d'un mobile"
            }
          },
          "row3": {
            "cell1": "Produits connectés",
            "cell2": "",
            "cell3": {
              "title": "UPS Galaxy VX 3-phase",
              "para": "Protèger la disponibilité de grandes installations, de centres de données et d'applications critiques grâce à cet UPS modulable"
            }
          }
        },
        "quote": {
          "text": "Nous avons créé un projet dont je suis très fier, et surtout, nous avons réduit nos coûts énergétiques de 60 % par rapport à un centre de données traditionnel.",
          "author": "Fran Muña",
          "title": "Directeur des infrastructures critiques,",
          "company": "Telefónica"
        },
        "vid": {
          "title": "Voyage numérique chez Telco",
          "description": "Moderniser pour les demandes croissantes d'énergie aussi bien aujourd'hui que demain "
        },
        "txtMedia1": {
          "title1": "Un exemple de réussite durable dans les centres de données",
          "title2": "Le développement durable chez Telefonica",
          "para1": "Au départ société de téléphonie, Telefónica avait pour ambition de devenir une société de télécommunications numérique, en créant un centre de données haute densité pour répondre à la demande client tout en réduisant ses coûts énergétiques. EcoStruxure™ pour les centres de données permet à son centre de données d’Alcalá de traiter pas moins de 14 kW par rack, tout en assurant la fiabilité du service et en réduisant les coûts énergétiques de 60 %, par comparaison à la certification traditionnelle DCIM et Gold Tier IV®."
        },
        "table2": {
          "title": "Solutions durables :",
          "row1": {
            "cell1": "Solution",
            "cell2": "Avantages"
          },
          "row2": {
            "cell1": "de surveillance à distance",
            "cell2": "Surveillance de l'état de chaque composant de l'installation en temps réel, permettant ainsi une détection précoce des pannes et le respect des normes les plus strictes en matière de fiabilité"
          },
          "row3": {
            "cell1": "Tableau électrique BT, éclairage de bâtiments, onduleurs",
            "cell2": "Réduction efficace de la consommation d'énergie et des émissions de CO2 ; système à technologie distribuée qui contrôle et surveille le bâtiment, tout en gérant de façon simultanée les alarmes et l'infrastructure énergétique"
          }
        },
        "tableText": {
          "title": "Résultats obtenus à ce jour :",
          "listItem1": "Réduction de 60 % des coûts d'énergie par comparaison à la certification traditionnelle DCIM et Gold Tier IV<sup>&reg;</sup>",
          "listItem2": "Capacité à connecter de nouveaux serveurs en mode exécution, sans devoir procéder à un arrêt pour reconfigurer ou reconcevoir des systèmes",
          "listItem3": "Un système BMS qui collecte des données pour environ 45 000 éléments",
          "p1": "<strong>Pour en savoir plus sur les défis, les solutions durables et les résultats de Telefónica</strong>",
          "ctaText": "En savoir plus"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/our-customers/our-customers-data-center-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/our-customers/our-customers-data-center-hero.jpg')" chapter="03" :section="$t('ourCustomers.section')" :title="$t('ourCustomers.title')"/>

    <section class="m-b-120 m-t-120">
      <Txt>
        <h2 v-html="$t('ourCustomers.data.txt1.title')"></h2>
        <p id="buildingsandit" v-html="$t('ourCustomers.data.txt1.para1')"></p>
        <p v-html="$t('ourCustomers.data.txt1.para2')"></p>
        <p v-html="$t('ourCustomers.data.txt1.para3')"></p>
        <ul>
          <li v-html="$t('ourCustomers.data.txt1.listItem1')"></li>
          <li v-html="$t('ourCustomers.data.txt1.listItem2')"></li>
          <li v-html="$t('ourCustomers.data.txt1.listItem3')"></li>
          <li v-html="$t('ourCustomers.data.txt1.listItem4')"></li>
        </ul>
      </Txt>
    </section>

    <section class="l-bg-white l-section-pad">
      <Table columns="3">
        <h2 id="datacentersolutions" slot="above" v-html="$t('ourCustomers.data.table1.title')"></h2>
        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.data.table1.row1.cell1')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/EcoStruxure-Asset-Advisor.jpg')" class="no-overlay">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.data.table1.row1.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.data.table1.row1.cell3.para')"></p>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <h3 class="t-green-light" v-html="$t('ourCustomers.data.table1.row2.cell1')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/EcoStruxure-IT-Expert-PNG.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.data.table1.row2.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.data.table1.row2.cell3.para')"></p>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.data.table1.row3.cell1')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/our-customers-data-centers-row3.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.data.table1.row3.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.data.table1.row3.cell3.para')"></p>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <!-- <section class="m-b-120 m-t-120">
      <ImageFull>
        <img src="../../assets/img/our-customers/our-customers-data-center-telefonica.jpg" />
      </ImageFull>
    </section> -->

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-80" videoId="hCz0ecZDzAg" :title="$t('ourCustomers.data.vid.title')" :description="$t('ourCustomers.data.vid.description')" :preview="require('@/assets/img/thumbnails/Telefonica.jpg')" />

      <TxtMedia>
        <h2 id="telefonicastory" class="m-b-45" slot="main-content" v-html="$t('ourCustomers.data.txtMedia1.title1')"></h2>
        <h3 class="m-b-15" slot="main-content" v-html="$t('ourCustomers.data.txtMedia1.title2')"></h3>
        <p slot="main-content" v-html="$t('ourCustomers.data.txtMedia1.para1')"></p>
        <img slot="sidebar" src="../../assets/img/our-customers/our-customers-data-center-telefonica.jpg" />
      </TxtMedia>
    </section>

    <section class="m-b-50 l-bg-white l-section-pad">
      <Table class="m-b-50" columns="2">
        <h2 id="telefonicasolutions" slot="above" v-html="$t('ourCustomers.data.table2.title')"></h2>
        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.data.table2.row1.cell1')"></h3>
            <p v-html="$t('ourCustomers.data.table2.row2.cell1')"></p>
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.data.table2.row1.cell2')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.data.table2.row2.cell2')"></p>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <h3 v-html="$t('ourCustomers.data.table2.row1.cell1')"></h3>
            <p v-html="$t('ourCustomers.data.table2.row3.cell1')"></p>
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.data.table2.row1.cell2')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.data.table2.row3.cell2')"></p>
          </TableCell>
        </TableRow>
      </Table>

      <Txt class="m-b-50">
        <h3 v-html="$t('ourCustomers.data.tableText.title')"></h3>
        <ul>
          <li v-html="$t('ourCustomers.data.tableText.listItem1')"></li>
          <li v-html="$t('ourCustomers.data.tableText.listItem2')"></li>
          <li v-html="$t('ourCustomers.data.tableText.listItem3')"></li>
        </ul>
      </Txt>

      <Quote class="m-b-50" :photo="require('../../assets/img/our-customers/our-customers-data-center-quote.jpg')" :name="$t('ourCustomers.data.quote.author')" :title="$t('ourCustomers.data.quote.title')" :company="$t('ourCustomers.data.quote.company')">
        <div v-html="$t('ourCustomers.data.quote.text')"></div>
      </Quote>

      <Txt>
        <p v-html="$t('ourCustomers.data.tableText.p1')" class="t-grey"></p>
        <CTA target="_blank" :buttonText="$t('ourCustomers.data.tableText.ctaText')" href="https://www.schneider-electric.com/en/work/campaign/life-is-on/case-study/telefonica.jsp"></CTA>
      </Txt>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="OurCustomers_Industry"
        prevRoute="OurCustomers_Building" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import ImageFull from '@/components/ImageFull'
import TxtMedia from '@/components/TxtMedia'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import YouTubeVideo from '@/components/YouTubeVideo'

export default {
  name: 'OurCustomers_DataCenter',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    ImageFull,
    TxtMedia,
    Table,
    TableRow,
    TableCell,
    Txt,
    YouTubeVideo
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/our-customers/data-center.vue